export default "/images/facebook-icon.svg?1600edef6d4ea2ea749e2abeaf4a0c9c";